import cx from 'classnames';
import lottiePlayer, { AnimationItem } from 'lottie-web';
import React, { forwardRef, useEffect, useImperativeHandle, useLayoutEffect, useRef } from 'react';

import styles from './styles.css';
import Box, { BoxProps } from '../Box';

interface LottieProps extends BoxProps {
  path?: string;
  animationData?: any;
  loop?: boolean;
  play?: boolean;
}

const Lottie = forwardRef<AnimationItem, LottieProps>(
  ({ path, animationData, loop = false, play = true, className, ...rest }, forwardedRef) => {
    const ref = useRef<HTMLDivElement>(null);
    const player = useRef<AnimationItem>();
    useImperativeHandle(forwardedRef, () => player.current!);

    useLayoutEffect(() => {
      player.current = lottiePlayer.loadAnimation({
        container: ref.current!,
        renderer: 'svg',
        loop,
        autoplay: play,
        path,
        animationData,
      });

      return () => {
        player.current!.destroy();
      };
    }, [path, animationData]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
      if (player.current) {
        player.current.loop = loop;

        if (player.current.isPaused && play) {
          player.current.play();
        } else if (!player.current.isPaused && !play) {
          player.current.pause();
        }
      }
    }, [loop, play]);

    return <Box ref={ref} className={cx(styles['lottie'], className)} {...rest} />;
  },
);

export default Lottie;
